import { isEqual, isAfter } from 'date-fns';

const isEqualOrAfter = (date: number | Date, dateToCompare: number | Date) =>
  isEqual(date, dateToCompare) || isAfter(date, dateToCompare);

export default isEqualOrAfter;
